import React from 'react';
import {
  List,
  Datagrid,
  TextField,
  DateField,
  Edit,
  SimpleForm,
  TextInput,
  Show,
  SimpleShowLayout,
  EditButton,
  ShowButton,
  TopToolbar,
  ExportButton,
  ReferenceField,
  DateTimeInput,
} from 'react-admin';

const BookingListActions = () => (
  <TopToolbar>
    <ExportButton />
  </TopToolbar>
);

export const BookingList = () => (
  <List actions={<BookingListActions />}>
    <Datagrid>
      <TextField source="id" />
      <TextField source="status" />
      <DateField source="startDate" />
      <ReferenceField source="userId" reference="users">
        <TextField source="name" />
      </ReferenceField>
      <ReferenceField source="workshopId" reference="workshops">
        <TextField source="name" />
      </ReferenceField>
      <DateField source="createdAt" />
      <ShowButton />
      <EditButton />
    </Datagrid>
  </List>
);

export const BookingEdit = () => (
  <Edit>
    <SimpleForm>
      <DateTimeInput source="startDate" />
      <TextInput source="note" multiline rows={4} />
    </SimpleForm>
  </Edit>
);

export const BookingShow = () => (
  <Show>
    <SimpleShowLayout>
      <TextField source="id" />
      <TextField source="status" />
      <DateField source="startDate" />
      <DateField source="finishedAt" />
      <TextField source="note" />
      <ReferenceField source="userId" reference="users">
        <TextField source="name" />
      </ReferenceField>
      <ReferenceField source="workshopId" reference="workshops">
        <TextField source="name" />
      </ReferenceField>
      <DateField source="createdAt" />
      <DateField source="updatedAt" />
    </SimpleShowLayout>
  </Show>
);
